/**
 * Labstep
 *
 * @module state/reducers/websocket
 * @desc Reducers for Websocket
 */

import { combineReducers } from 'redux';

// State interface
export interface StateWebsocket {
  connected: boolean;
  room: string | null;
  users: WebsocketUser[];
}

// Action types
export interface WebsocketConnectAction {
  type: 'WEBSOCKET_CONNECT';
}

export interface WebsocketDisconnectAction {
  type: 'WEBSOCKET_DISCONNECT';
}

export interface WebsocketErrorAction {
  type: 'WEBSOCKET_ERROR';
}

export interface JoinRoomAction {
  type: 'JOIN_ROOM';
  meta?: {
    room: string;
  };
}

export interface WebsocketMessageAction {
  type: 'WEBSOCKET_MESSAGE';
  payload?:
    | {
        type: 'connected_users';
        users: WebsocketUser[];
      }
    | {
        type: string;
        [key: string]: any;
      };
}

// Union type for all websocket actions
export type WebsocketAction =
  | WebsocketConnectAction
  | WebsocketDisconnectAction
  | WebsocketErrorAction
  | JoinRoomAction
  | WebsocketMessageAction;

// User interface for connected users
export interface WebsocketUser {
  id: string;
  name?: string;
  email?: string;
  avatar?: string;
  [key: string]: any;
}

/**
 * Websocket connected
 */
export const connected = (state = false, action) => {
  if (action.type === 'WEBSOCKET_CONNECT') {
    return true;
  }
  if (action.type === 'WEBSOCKET_DISCONNECT') {
    return false;
  }
  if (action.type === 'WEBSOCKET_ERROR') {
    return false;
  }

  return state;
};

/**
 * Websocket room
 */
export const room = (state = null, action) => {
  if (action.type === 'JOIN_ROOM' && action.meta) {
    return action.meta.room;
  }

  return state;
};

/**
 * Websocket list of connected users
 */
export const users = (state = [], action) => {
  if (
    action.type === 'WEBSOCKET_MESSAGE' &&
    action.payload &&
    action.payload.type === 'connected_users'
  ) {
    return action.payload.users;
  }

  return state;
};

const reducers: any = combineReducers({
  connected,
  room,
  users,
});

export default reducers;
